import {styled} from "@mui/material/styles"

export const List = styled("ul")`
    align-items: center;
    display: flex;
    margin: 0;
    padding: 0;
    flex-shrink: 0;
`
